// Espelho de backend/src/utils/tarefaVencida.ts — tarefa nesses status NÃO conta
// como vencida/atrasada mesmo com prazo no passado (concluída ou parada na coluna
// "Aguardando cliente"). Mantém o kanban/lista coerentes com dashboard/backend.
export const STATUS_TAREFA_NAO_VENCE = ["concluido", "aguardando_cliente"];

/** true se a tarefa AINDA pode ser considerada vencida (cobra da equipe). */
export function tarefaPodeVencer(status: string | undefined | null): boolean {
  return !STATUS_TAREFA_NAO_VENCE.includes(status || "");
}
